import store from '../store';
const defaultSetting = {};
defaultSetting.mainHostUrl = "";

var token = '';

// merchant_web_app ရဲ့ X-API-KEY — `.env` ထဲမှာ VITE_MERCHANT_WEBSITE_KEY="${MERCHANT_WEBSITE_26_10_31_WEB_KEY}"
// လို့ ညွှန်ထားလို့ key value က merchant scanner နဲ့ တစ်နေရာတည်းမှာပဲ ရှိသည်။
// Vite က build ချိန်မှာ ထည့်တာမို့ key ပြောင်းရင် `npm run build` ပြန် run ရမည်။
const API_KEY = import.meta.env.VITE_MERCHANT_WEBSITE_KEY;

// Key မပါဘဲ build လုပ်မိရင် request တိုင်း 401 ပဲ ရမှာမို့ အကြောင်းရင်းကို console မှာ ပြသည်။
if (!API_KEY) {
    console.error("VITE_MERCHANT_WEBSITE_KEY is not set — every API request will be rejected with 401.");
}

defaultSetting.requestHeader = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-API-KEY": API_KEY,
    Authorization: `Bearer ${token}`,
};
defaultSetting.fileRequestHeader = {
    Accept: "application/json",
    "Content-Type": "multipart/form-data",
    "X-API-KEY": API_KEY,
    Authorization: `Bearer ${token}`,
};
export default defaultSetting;
